import { render, staticRenderFns } from "./OrderTypeToggle.vue?vue&type=template&id=d279d290&scoped=true"
import script from "./OrderTypeToggle.vue?vue&type=script&lang=ts"
export * from "./OrderTypeToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d279d290",
  null
  
)

export default component.exports